import { CancelToken } from "axios";

import { IAPIError } from "shared/types";
import { APIService } from "shared/services";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { IDataKeys, IJSONAPIItem } from "shared/types";
import { IUserTravelVisaPatchData } from "Bands/types";

interface IJSONAPIData {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIUserTravelVisaCollection {
  [IDataKeys.userTravelVisa]: IJSONAPIData;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class UserTravelVisaService {
  static createUserTravelVisa = (
    data: IUserTravelVisaPatchData
  ): Promise<IJSONAPIUserTravelVisaCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.post({
          path: API_ENDPOINTS.USER_TRAVEL_VISAS,
          data,
        });
        resolve(response as IJSONAPIUserTravelVisaCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.POST_USER_TRAVEL_VISA);
        reject({ error });
      }
    });

  static getUserTravelVisas = (
    queryParams?: string | { [key: string]: string | number | undefined | string[] },
    cancelToken?: CancelToken
  ): Promise<IJSONAPIUserTravelVisaCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.get({
          path: API_ENDPOINTS.USER_TRAVEL_VISAS,
          data: queryParams,
          cancelToken,
        });
        resolve(response as IJSONAPIUserTravelVisaCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_USER_TRAVEL_VISAS);
        reject({ error });
      }
    });

  static editUserTravelVisa = (
    id: string,
    data: IUserTravelVisaPatchData
  ): Promise<IJSONAPIUserTravelVisaCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.patch({
          path: API_ENDPOINTS.USER_TRAVEL_VISA(id),
          data,
        });
        resolve(response as IJSONAPIUserTravelVisaCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_USER_TRAVEL_VISA);
        reject({ error });
      }
    });

  static deleteUserTravelVisa = (id: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.USER_TRAVEL_VISA(id),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.DELETE_USER_TRAVEL_VISA);
        reject({ error });
      }
    });
}
